import React, { Component } from 'react'
import './style.css'
import axios from "../../store/http/axios"


class Auth extends Component {

  state = {
    email: "",
    password: ""
  }

  login = async e => {
    e.preventDefault()

    const { email, password } = this.state

    try {
      await axios.post('/auth/admin/login', {
        email,
        password
      })

      window.location.reload()
    } catch (err) {
      console.error(err)
    }

  }

  render() {

    const { email, password } = this.state

    return (
      <React.Fragment>
        <div className="auth-container">
          <form onSubmit={this.login}>
            <input name="email" type="text" placeholder="Email" onChange={e => this.setState({ email: e.target.value })} />
            <input name="password" type="password" placeholder="Password" onChange={e => this.setState({ password: e.target.value })} />
            <button disabled={!email.length && !password.length}>Login</button>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/views/Auth/index.js